import React from 'react'
import { Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import { usePostResendSMSEndUserAppleLuckyDraw } from '../../../../../api/promotions/end-user/end-user-apple-lucky-draw'

const ResendButton = ({ id }) => {
  const { mutateAsync, isLoading } = usePostResendSMSEndUserAppleLuckyDraw(id)

  const { enqueueSnackbar } = useSnackbar()

  const handleApprove = async () => {
    try {
      const res = await mutateAsync()

      // Display success on popup
      enqueueSnackbar(`Resent SMS successfully`, {
        variant: 'success',
      })
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to resend SMS', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  return (
    <Button variant='contained' size='large' disabled={isLoading} onClick={handleApprove}>
      Resend Sms
    </Button>
  )
}

export default ResendButton
